import React, { useEffect, useState } from "react";
import {
  Row,
  Col,
  Collapse,
  FormGroup,
  Label,
  Input,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
} from "reactstrap";
import ReactStars from "react-rating-stars-component";
import { showToast, t } from "../../../utils/utils";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faStar, faStarHalfAlt } from "@fortawesome/free-solid-svg-icons";
import T from "../../atoms/translate";
import { FEEDBACK_API, GET_JWT, GET_USER_EMAIL } from "../../../constants";
import { ADD_FEEDBACK } from "../../../api/feedback";
import API from "../../../api/API";
import { setContext } from "apollo-link-context";
import ApolloClient from "apollo-client";
import { InMemoryCache } from "apollo-cache-inmemory";
import { createHttpLink } from "apollo-link-http";

const httpLink = createHttpLink({
  uri: FEEDBACK_API,
});

const authLink = setContext((_, { headers }) => {
  // get the authentication token from local storage if it exists
  const token = GET_JWT();
  // return the headers to the context so httpLink can read them
  return {
    headers: {
      ...headers,
      authorization: token ? `Bearer ${token}` : "",
    },
  };
});

const client = new ApolloClient({
  link: authLink.concat(httpLink),
  cache: new InMemoryCache({
    dataIdFromObject: (object) => object.id || null,
  }),
});

const Feedback = ({ isOpen, onFinish, project }) => {
  const [feedbackOpen, setFeedbackOpen] = useState(
    isOpen !== undefined ? isOpen : true
  );
  const [saving, setSaving] = useState(false);
  const [stars, setStars] = useState(0);
  const [comment, setComment] = useState("");

  const onRatingChange = (rating) => {
    setStars(rating);
  };

  const onChange = (evt) => {
    setComment(evt.target.value);
  };

  const onSubmit = async (evt) => {
    evt.preventDefault();
    setSaving(true);
    try {
      await API.mutation(client, ADD_FEEDBACK, {
        user: GET_USER_EMAIL(),
        email: GET_USER_EMAIL(),
        value: stars.toString(),
        comment: comment,
        date: new Date().getTime().toString(),
        status: "PENDING",
        project: project,
      });
    } catch (error) {
      console.log(error);
    } finally {
      setSaving(false);
      setFeedbackOpen(false);
      showToast(t("exitoAlEnviarFeedback"));
    }
  };

  useEffect(() => {
    setFeedbackOpen(isOpen);
  }, [isOpen]);
  return (
    <Modal
      id="feedback-modal"
      isOpen={feedbackOpen}
      size={"md"}
      contentClassName="generic-modal"
      centered
    >
      <ModalHeader>{t("valoraTuExperiencia")}</ModalHeader>
      <ModalBody>
        <Row>
          <Col xs="12">
            <ReactStars
              count={5}
              onChange={onRatingChange}
              size={40}
              emptyIcon={<FontAwesomeIcon icon={faStar} />}
              halfIcon={<FontAwesomeIcon icon={faStarHalfAlt} />}
              filledIcon={<FontAwesomeIcon icon={faStar} />}
              activeColor="#ffd700"
              classNames="mx-auto"
            />
            <Collapse isOpen={stars > 0}>
              <FormGroup className="mt-4">
                <Label>
                  <T
                    i18nKey={t(
                      stars < 4
                        ? "cuentanosQueSalioMal"
                        : stars < 5
                        ? "enQuePodemosMejorar"
                        : "queEsLoQueTeGusto"
                    )}
                  />
                </Label>
                <Input
                  id="comentario"
                  name="comentario"
                  type="textarea"
                  value={comment}
                  placeholder=""
                  onChange={onChange}
                />
              </FormGroup>
            </Collapse>
          </Col>
        </Row>
      </ModalBody>
      <ModalFooter>
        <Col xs="9" md="5" className="mx-auto">
          <Button
            block
            color="primary"
            disabled={stars === 0}
            onClick={onSubmit}
          >
            {saving ? t("procesando...") : t("enviarFeedback")}
          </Button>
        </Col>
      </ModalFooter>
    </Modal>
  );
};

export default Feedback;
